var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "operation" },
    [
      !_vm.breakpointDownMd
        ? _c("div", { staticClass: "years" }, [
            _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.prevYear()
                  },
                },
              },
              [_c("span", { staticClass: "icon-arrow-right prev" })]
            ),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.activeYearLabel))]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.nextYear()
                  },
                },
              },
              [_c("span", { staticClass: "icon-arrow-right next" })]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.breakpointDownMd && _vm.mobileYear !== null
        ? _c("custom-select", {
            staticClass: "mobile-custom-select",
            attrs: {
              "value-field": "year",
              "label-field": "year",
              options: _vm.items,
            },
            on: {
              change: function ($event) {
                return _vm.changeYear()
              },
            },
            model: {
              value: _vm.mobileYear,
              callback: function ($$v) {
                _vm.mobileYear = $$v
              },
              expression: "mobileYear",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "op-filters" },
        _vm._l(_vm.opeList, function (item, index) {
          return _c("li", { class: _vm.opeClasses(item, index) }, [
            _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.goUrl(item, index)
                  },
                },
              },
              [_vm._v(_vm._s(item.label))]
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }